<template>
    <div class="z-remind">
        <div class="z-remind__trigger"
             :class="{'z-remind__trigger--opened': isOpened}"
             ref="remind">
            <slot name="trigger"/>
            <z-button 
                v-if="!$slots.trigger" 
                kind="bordered" 
                size="s" 
                only-icon
                class="z-remind__trigger-button"
            >
                <template v-slot:left>
                    <z-icon name="calendar/calendar-add" width="24" height="24" />
                </template>
            </z-button>
        </div>
        <div class="z-remind__content" ref="content">
            <span v-if="showTitle" class="z-remind__title">
                {{ text.addToCalendar }}
            </span>
            <slot name="content"/>
            <z-link
                v-for="(item, index) in data"
                :underlined="false"
                theme="dark"
                :href="item.link"
                :key="index"
                :target="item.type === 'google' ? '_blank' : false"
                :download="item.type !== 'google' ? item.type : ''"
            >
                <z-icon
                    :name="`calendar/${item.type}`"
                    width="28"
                    height="28"
                />
                <span class="z-remind__text">
                    {{ item.text }}
                </span>
            </z-link>
        </div>
    </div>
</template>

<script setup>
import {onMounted, ref} from 'vue'
import tippy from 'tippy.js'
import {localize} from '@/utils/i18n'

const text = {
    addToCalendar: localize({
        ru: 'Добавить в календарь',
        en: 'Add to calendar',
        cn: 'Add to calendar'
    })
}

const props = defineProps({
    data: {
        type: [Array, Object]
    },
    placement: {
        type: String,
        default: 'right-start'
    },
    showTitle: {
        type: Boolean,
        default: true
    }
})

const isOpened = ref(false)
const content = ref(null)
const remind = ref(null)

const initTippy = () => {
    tippy(remind.value, {
        content: content.value,
        arrow: false,
        placement: props.placement,
        theme: 'remind',
        interactive: true,
        trigger: 'click focus',
        onShow () {
            isOpened.value = true
        },
        onHide () {
            isOpened.value = false
        }
    })
}

onMounted(() => {
    initTippy()
})

defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
